/* Praevaleo Shop: Menü (Mega + Seitenfach), Kollektion (Sortierung, Mehr anzeigen), Warenkorb (Kombinieren, Geschenk). */
(async () => {
  if (window.__pvShop) return;
  window.__pvShop = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  const root$ = document.documentElement;

  /* ---------- Mega-Menü (Computer) ---------- */
  const mega = $('[data-pv-mega]');
  const scrim = $('[data-pv-scrim]');
  let megaTimer;
  // Alle Links der Kopfzeile öffnen das Mega-Menü (Dragos 02.11.), nicht nur „Shop“.
  const NAV = '.pv-hdr .pv-nav a, [data-pv-trigger]';
  function placeMega() {
    const h = document.querySelector('[data-pv-hdr-bar]') || document.getElementById('header-component');
    const bottom = h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
    if (mega) mega.style.top = bottom + 'px';
    if (scrim) scrim.style.top = bottom + 'px';
  }
  function openMega() {
    if (!mega || isMobile()) return;
    clearTimeout(megaTimer);
    placeMega();
    mega.hidden = false;
    // Kopfzeile kann beim Öffnen noch einrasten: einen Bildaufbau später nachmessen, sonst bleibt ein Spalt.
    requestAnimationFrame(() => requestAnimationFrame(placeMega));
    $$('img[loading="lazy"]', mega).forEach((i) => (i.loading = 'eager'));
    scrim.hidden = false;
    root$.classList.add('pv-mega-open');
    const t = $('[data-pv-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeMega() {
    if (!mega) return;
    clearTimeout(megaTimer);
    mega.hidden = true;
    scrim.hidden = true;
    root$.classList.remove('pv-mega-open');
    const t = $('[data-pv-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  const laterClose = () => {
    clearTimeout(megaTimer);
    megaTimer = setTimeout(closeMega, 160);
  };
  if (mega) {
    const trigger = () => $('[data-pv-trigger]');
    document.addEventListener('mouseover', (e) => {
      const t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      if (t.closest(NAV)) openMega();
      else if (t.closest('[data-pv-mega]')) clearTimeout(megaTimer);
      else if (t.closest('[data-pv-scrim]') || !t.closest('[data-pv-hdr], #header-group')) { if (!mega.hidden) laterClose(); }
    });
    document.addEventListener('mouseout', (e) => {
      const t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      if (t.closest(NAV) || t.closest('[data-pv-mega]')) laterClose();
    });
    document.addEventListener('click', (e) => {
      const t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      const tr = t.closest('[data-pv-trigger]');
      if (tr && !isMobile() && !e.metaKey && !e.ctrlKey && !e.shiftKey && mega.hidden) {
        e.preventDefault();
        openMega();
        return;
      }
      if (t.closest('[data-pv-scrim]')) closeMega();
    });
    document.addEventListener('focusin', (e) => {
      if (e.target instanceof Element && e.target.closest(NAV)) openMega();
    });
    window.addEventListener('scroll', () => { if (!mega.hidden) placeMega(); }, { passive: true });
    window.addEventListener('resize', closeMega);
    void trigger;
  }

  /* ---------- Seitenfach (Handy) ---------- */
  const drawer = $('[data-pv-drawer]');
  let lastFocus = null;
  async function refreshCount() {
    try {
      const c = await fetch(root + 'cart.js').then((r) => r.json());
      $$('[data-pv-cart-count]').forEach((n) => { n.textContent = c.item_count; n.hidden = !c.item_count; });
    } catch (err) {}
  }
  // Feinschliff 02.11.: Fach blendet mit transform/opacity ein und aus; Fokus geht danach auf den Menü-Knopf zurück
  // (Safari fokussiert Knöpfe beim Tippen nicht, darum nicht auf activeElement verlassen).
  let drawerTimer = 0;
  function openDrawer() {
    if (!drawer) return;
    clearTimeout(drawerTimer);
    const a = document.activeElement;
    lastFocus = a && a !== document.body && !drawer.contains(a) ? a : $$('.pv-hdr__bar [data-pv-menu]').find((b) => b.offsetParent) || null;
    drawer.hidden = false;
    $$('img[loading="lazy"]', drawer).forEach((i) => (i.loading = 'eager'));
    root$.classList.add('pv-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
    $('[data-pv-drawer-close]', drawer)?.focus({ preventScroll: true });
    refreshCount();
  }
  function closeDrawer(instant) {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    root$.classList.remove('pv-lock');
    const done = () => { drawer.hidden = true; };
    clearTimeout(drawerTimer);
    if (instant === true || matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else drawerTimer = setTimeout(done, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.addEventListener('pagehide', () => closeDrawer(true));
  if (drawer) {
    document.addEventListener(
      'click',
      (e) => {
        const t = e.target instanceof Element ? e.target : null;
        if (!t) return;
        const s = t.closest('[data-pv-menu], header-drawer summary');
        if (s && isMobile()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openDrawer();
          return;
        }
        if (t.closest('[data-pv-drawer-close]')) { closeDrawer(); return; }
        // Tippen auf einen Link im Fach: Fach schließt, die Seite wechselt normal.
        const ln = t.closest('a[href]');
        if (ln && drawer.contains(ln) && !ln.closest('.pv-drawer__cart')) closeDrawer(true);
      },
      true
    );
    window.addEventListener('resize', () => { if (!isMobile()) closeDrawer(); });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeMega();
    closeDrawer();
    $$('[data-pv-dd][open]').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------- Kollektion ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    const dd = $$('[data-pv-dd][open]');
    dd.forEach((d) => { if (!d.contains(t)) d.removeAttribute('open'); });
    const sort = t.closest('[data-pv-sort]');
    if (sort) {
      e.preventDefault();
      const u = new URL(location.href);
      u.searchParams.set('sort_by', sort.dataset.pvSort);
      u.searchParams.delete('page');
      u.searchParams.delete('pv_p');
      location.href = u.toString();
      return;
    }
    const more = t.closest('[data-pv-more]');
    if (more) {
      e.preventDefault();
      loadMore(more);
    }
  });
  async function loadMore(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Lädt';
    try {
      var fetched = btn.href;
      const html = await fetch(fetched).then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      });
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-pv-grid]');
      const fresh = $$('[data-pv-grid] > *', doc);
      fresh.forEach((n) => grid.appendChild(document.importNode(n, true)));
      const count = $('[data-pv-count]', doc);
      if (count) $('[data-pv-count]').textContent = count.textContent;
      const prog = $('[data-pv-progress]', doc);
      if (prog) $('[data-pv-progress]').style.width = prog.style.width;
      const next = $('[data-pv-more]', doc);
      if (next) {
        btn.href = next.href;
        btn.textContent = 'Mehr anzeigen';
        btn.removeAttribute('aria-busy');
      } else {
        btn.remove();
      }
      // Stand merken: nach Zurück aus einem Produkt werden die Seiten bis hierher wieder geladen (Fehlerbericht 02.11.).
      const got = new URL(fetched, location.href).searchParams.get('page');
      if (got) { const u = new URL(location.href); u.searchParams.set('pv_p', got); history.replaceState(history.state, '', u.toString()); }
    } catch (err) {
      btn.textContent = 'Mehr anzeigen';
      btn.removeAttribute('aria-busy');
      location.href = btn.href;
    }
  }

  // Zurück aus einem Produkt: nachgeladene Seiten wieder holen, dann die alte Scrollposition setzen.
  (async () => {
    const btn = $('[data-pv-more]');
    const want = +new URL(location.href).searchParams.get('pv_p') || 0;
    const key = 'pv-coll-y:' + location.pathname; // ohne Suchteil, der Vorschau-Parameter fällt beim Zurück weg
    window.addEventListener('pagehide', () => { try { sessionStorage.setItem(key, String(Math.round(scrollY))); } catch (e) {} });
    if (!btn || want < 2) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    let guard = 0;
    while (guard++ < 20) {
      const b = $('[data-pv-more]');
      if (!b) break;
      const p = +new URL(b.href, location.href).searchParams.get('page') || 0;
      if (!p || p > want) break;
      await loadMore(b);
    }
    let y = 0;
    try { y = +sessionStorage.getItem(key) || 0; } catch (e) {}
    if (y) requestAnimationFrame(() => window.scrollTo(0, y));
  })();

  /* ---------- Warenkorb: Geschenk und Kombinieren ---------- */
  let CartAddEvent = null;
  try {
    ({ CartAddEvent } = await import('@theme/events'));
  } catch (err) {}
  // Neuere Horizon-Fassungen haben keinen CartAddEvent mehr: gleichwertiges cart:update-Ereignis.
  if (!CartAddEvent) {
    CartAddEvent = class extends CustomEvent {
      constructor(resource, sourceId, data) { super('cart:update', { bubbles: true, detail: { resource, sourceId, data: data || {} } }); }
    };
  }

  document.addEventListener('click', async (e) => {
    const t = e.target instanceof Element ? e.target : null;
    const btn = t && t.closest('[data-pv-gift]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    btn.setAttribute('aria-disabled', 'true');
    const msg = $('.pv-gift__msg', btn.closest('.pv-gift') || document);
    if (msg) msg.textContent = '';
    try {
      const sections = $$('cart-items-component').map((el) => el.dataset.sectionId).filter(Boolean);
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.pvGift), quantity: 1, properties: { _pv_geschenk: '1' } }], sections: sections.join(','), sections_url: location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Fehler');
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      if (CartAddEvent) {
        btn.dispatchEvent(new CartAddEvent(cart, 'pv-gift', { source: 'pv-gift', itemCount: cart.item_count, variantId: String(btn.dataset.pvGift), sections: data.sections }));
      } else {
        location.reload();
      }
    } catch (err) {
      if (msg) msg.textContent = 'Gerade nicht verfügbar';
      btn.removeAttribute('aria-disabled');
    }
  });

  if (!CartAddEvent) return;


    const cache = new Map();
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const arrow = (d) =>
      `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">${
        d < 0 ? '<path d="M15 6l-6 6 6 6"/>' : '<path d="M9 6l6 6-6 6"/>'
      }</svg>`;

    // Outfit-Regel nach Produkttyp. Neue Produkttypen hier einer Gruppe zuordnen.
    const GROUPS = {
      top: ['t-shirts', 'longsleeves', 'flannels', 'hoodies', 'sweatshirts', 'hemden', 'oberteile'],
      bottom: ['jeans', 'jogger', 'hosen', 'shorts'],
      jacket: ['jacken'],
      set: ['sets'],
    };
    const NICE = ['ink jeans', 'storm jacket', 'quilt jacket', 'drip jeans', 'x-ray sweatshirt', 'mud jeans', 'copycat sweatshirt', 'blank jacket', 'line jeans', 'flare jeans', 'crop denim jacket', 'straight jeans', 'fade jeans', 'crop zip hoodie', 'flip jacket', 'fray shirt', 'stud flannel', 'bias sweatshirt', 'layer shirt', 'grid shirt', 'force sweatshirt'];
    const groupOf = (type) => {
      const t = String(type || '').trim().toLowerCase();
      return Object.keys(GROUPS).find((g) => GROUPS[g].includes(t)) || null;
    };
    function wanted(groups) {
      if (groups.has('set') || (groups.has('top') && groups.has('bottom'))) return groups.has('jacket') ? [] : ['jacket'];
      if (groups.has('top')) return ['bottom'];
      if (groups.has('bottom')) return ['top'];
      if (groups.has('jacket')) return ['bottom', 'top'];
      return [];
    }

    function money(cents, format) {
      const n = cents / 100;
      const fix = (d, ts, ds) => {
        const [i, f] = n.toFixed(d).split('.');
        const int = i.replace(/\B(?=(\d{3})+(?!\d))/g, ts);
        return f ? int + ds + f : int;
      };
      return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
        if (k === 'amount') return fix(2, ',', '.');
        if (k === 'amount_no_decimals') return fix(0, ',', '.');
        if (k === 'amount_no_decimals_with_comma_separator') return fix(0, '.', ',');
        return fix(2, '.', ',');
      });
    }

    // Abrufe liefern die Liste oder null bei Fehler, damit ein Ausfall nicht als „leer“ gilt und erneut versucht wird.
    function cached(key, url, pick) {
      if (!cache.has(key)) {
        const request = fetch(url)
          .then((r) => {
            if (!r.ok) throw new Error(String(r.status));
            return r.json();
          })
          .then(pick)
          .catch(() => {
            cache.delete(key);
            return null;
          });
        cache.set(key, request);
      }
      return cache.get(key);
    }

    const recommend = (productId) =>
      cached(`c:${productId}`, `${root}recommendations/products.json?product_id=${productId}&limit=6&intent=complementary`, (d) => d.products || []);

    // Look-Partner aus dem Metafeld custom.look_partner (gleiches Format wie die Empfehlungen).
    const lookOf = (handle) => cached(`l:${handle}`, `${root}products/${handle}.js`, (d) => d);

    // Der Katalog bringt den Produkttyp mit; Preise kommen als Text und werden auf Cent umgerechnet.
    const catalog = () =>
      cached('catalog', `${root}products.json?limit=250`, (d) =>
        (d.products || []).map((p) => {
          const cents = (v) => (v == null || v === '' ? 0 : Math.round(parseFloat(v) * 100));
          const variants = (p.variants || []).map((v) => ({
            id: v.id,
            available: v.available !== false,
            price: cents(v.price),
            compare: cents(v.compare_at_price),
            options: [v.option1, v.option2, v.option3].filter((o) => o != null),
          }));
          const cheapest = variants.reduce((a, b) => (b.price < a.price ? b : a), variants[0] || { price: 0, compare: 0 });
          return {
            id: p.id,
            title: p.title,
            type: p.product_type,
            url: `${root}products/${p.handle}`,
            featured_image: p.images?.[0]?.src || null,
            options: (p.options || []).map((o) => ({ name: o.name, values: o.values })),
            variants,
            available: variants.some((v) => v.available),
            price: cheapest.price,
            compare_at_price: cheapest.compare,
            price_varies: variants.some((v) => v.price !== cheapest.price),
          };
        })
      );

    function interleave(lists) {
      const out = [];
      const max = Math.max(0, ...lists.map((l) => l.length));
      for (let i = 0; i < max; i++) for (const l of lists) if (l[i]) out.push(l[i]);
      return out;
    }

    class PvCombine extends HTMLElement {
      static observedAttributes = ['data-ids', 'data-types'];

      connectedCallback() {
        this.addEventListener('click', this.#onClick);
        this.addEventListener('change', this.#onChange);
        // Erst laden, wenn die Schublade offen ist, nicht auf jeder Seite.
        this._observer = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this._seen = true;
            this.#sync();
          }
        });
        this._observer.observe(this.closest('.cart-drawer__items, .pv-cart__scroll') || this);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
        this.removeEventListener('change', this.#onChange);
        this._observer?.disconnect();
        clearTimeout(this._pendingTimer);
      }

      // Das Theme setzt Produkte und Typen nacheinander; erst rechnen, wenn beide neu sind.
      attributeChangedCallback() {
        if (!this.isConnected || !this._seen || this._queued) return;
        this._queued = true;
        queueMicrotask(() => {
          this._queued = false;
          this.#sync();
        });
      }

      #done() {
        if (this._pending) {
          this._pending = false;
          clearTimeout(this._pendingTimer);
          this.#setBusy(false);
        }
        if (!this._focusAfter) return;
        this._focusAfter = false;
        const target = this.querySelector('.pv-combine__title') || document.getElementById('cart-drawer-heading');
        target?.focus();
      }

      async #sync() {
        const ids = (this.dataset.ids || '').split(',').filter(Boolean);
        const looks = (this.dataset.looks || '').split(',').filter(Boolean);
        const key = `${ids.join(',')}|${this.dataset.types || ''}|${looks.join(',')}|${this.dataset.lkB}|${this.dataset.lkT}|${this.dataset.lkOn}`;
        if (key === this._key) return this.#done();
        this._key = key;
        if (!ids.length) {
          this.replaceChildren();
          return this.#done();
        }

        try {
          const groups = new Set((this.dataset.types || '').split(',').map(groupOf).filter(Boolean));
          const want = wanted(groups);
          const [lookParts, complementary, products] = await Promise.all([
            Promise.all(looks.slice(0, 3).map((h) => lookOf(h))),
            Promise.all(ids.slice(0, 3).map((id) => recommend(id))),
            want.length ? catalog() : Promise.resolve([]),
          ]);
          if (this._key !== key) return;

          // Gepflegte Kombinationen zuerst, aber nur, wenn sie zur Regel passen; Gruppen abwechselnd mischen.
          const manual = interleave(complementary.filter(Boolean));
          const fits = (p) => !want.length || want.includes(groupOf(p.type));
          const byRule = interleave(want.map((g) => (products || []).filter((p) => groupOf(p.type) === g)));
          // Nur Dragos' Auswahl (02.11.2026), in seiner Reihenfolge; Look-Teil aus dem Metafeld zuerst, wenn es passt.
          const rank = (p) => NICE.indexOf(String(p.title || '').trim().toLowerCase());
          const nice = (list) => list.filter((p) => rank(p) > -1 && fits(p));
          const ruled = nice((products || []).filter((p) => want.includes(groupOf(p.type)))).sort((x, y) => rank(x) - rank(y));
          // Lieblingsteile nur bevorzugen: danach die übrigen Teile der Regel, damit der Vorschlag nie leer ist.
          const rest = (products || []).filter((p) => want.includes(groupOf(p.type)) && rank(p) === -1);
          const pool = [...nice(lookParts.filter(Boolean).map((p) => ({ ...p, type: p.type || p.product_type }))), ...ruled, ...rest];
          const failed = complementary.every((l) => l === null) && (!want.length || products === null);

          const seen = new Set(ids.map(Number));
          const picks = [];
          for (const p of pool) {
            if (picks.length === 6) break;
            if (seen.has(p.id) || !p.available || !p.variants?.some((v) => v.available)) continue;
            seen.add(p.id);
            picks.push(p);
          }
          if (!picks.length) {
            if (failed) this._key = undefined;
            this.replaceChildren();
            return this.#done();
          }

          this._picks = picks;
          this._index = 0;
          this.#frame();
          this.#done();
        } catch (error) {
          this._key = undefined;
          this.replaceChildren();
          this.#done();
        }
      }

      #frame() {
        const single = this._picks.length === 1;
        const added = this._added ? `<span class="pv-combine__sr">, ${esc(this._added)} hinzugefügt</span>` : '';
        this._added = '';
        const nav = single
          ? ''
          : `<div class="pv-combine__navs"><button type="button" class="pv-combine__nav" data-step="-1" aria-label="Vorheriges Produkt">${arrow(-1)}</button><button type="button" class="pv-combine__nav" data-step="1" aria-label="Nächstes Produkt">${arrow(1)}</button></div>`;
        this.innerHTML = `<div class="pv-combine__head"><h3 class="pv-combine__title" tabindex="-1">Den Look vervollständigen${added}</h3>${nav}</div>
          <div class="pv-combine__item"></div>`;
        this.#show();
      }

      #show() {
        const item = this.querySelector('.pv-combine__item');
        const p = this._picks?.[this._index];
        if (!item || !p) return;
        const format = this.dataset.money;
        const varying = (p.options || []).map((o, i) => ({ ...o, i })).filter((o) => o.values?.length > 1);
        const img = p.featured_image
          ? `<img src="${esc(p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=180')}" alt="" width="72" height="90" loading="lazy">`
          : '';
        const price = `${p.price_varies ? 'ab ' : ''}${money(p.price, format)}`;
        const compare =
          p.compare_at_price > p.price
            ? `<span class="pv-combine__sr">, vorher </span><s>${esc(money(p.compare_at_price, format))}</s>`
            : '';
        const available = p.variants.filter((v) => v.available);
        this._sel = {};
        let action;
        if (!varying.length && p.variants.length > 1) {
          // Varianten ohne lesbare Optionen: nicht raten, sondern zur Produktseite.
          action = `<a class="pv-combine__add" href="${esc(p.url)}">Ansehen</a>`;
        } else {
          // Je Option eine Reihe Knöpfe (Farbe, Größe); nicht lieferbare Werte gesperrt, einziger Wert vorgewählt.
          const groups = varying
            .map((o) => {
              const usable = o.values.filter((value) => available.some((v) => v.options[o.i] === value));
              if (usable.length === 1) this._sel[o.i] = usable[0];
              const chips = o.values
                .map((value) => {
                  const on = this._sel[o.i] === value;
                  return `<button type="button" class="pv-combine__chip" data-opt="${o.i}" data-val="${esc(value)}" aria-pressed="${on}">${esc(value)}</button>`;
                })
                .join('');
              return `<div class="pv-combine__opt" role="group" aria-label="${esc(o.name + ' für ' + p.title)}" data-name="${esc(o.name)}">${chips}</div>`;
            })
            .join('');
          const add = `<button type="button" class="pv-combine__add" data-add${varying.length ? '' : ` data-variant="${available[0].id}"`} aria-label="${esc('In den Warenkorb: ' + p.title)}">In den Warenkorb</button>`;
          action = groups + add;
        }
        // Look-Rabatt wie auf der Produktseite (Dragos 03.11.2026): Hose zu Oberteil oder umgekehrt, 10 % auf ein Teil (Rechnung siehe unten).
        // Nur zeigen, wenn im Warenkorb die Gegenseite liegt und noch kein Look-Rabatt greift.
        const LOOK_PCT = 10;
        const side = { jeans: 'b', jogger: 'b', longsleeves: 't', hoodies: 't', jacken: 't', 't-shirts': 't', flannels: 't' }[String(p.type || '').trim().toLowerCase()];
        // Fix 03.11.2026: Jede Regel rabattiert das günstigste Teil ihrer Bekomme-Seite, Shopify nimmt die bessere.
        // data-lk-b/-t sind die günstigsten Teile je Seite im Warenkorb; der Vorschlag zählt zu seiner Seite dazu.
        const opp = side === 't' ? +this.dataset.lkB || 0 : side === 'b' ? +this.dataset.lkT || 0 : 0;
        const ownMin = side === 't' ? +this.dataset.lkT || 0 : side === 'b' ? +this.dataset.lkB || 0 : 0;
        const own = ownMin ? Math.min(ownMin, p.price) : p.price;
        const save = opp && this.dataset.lkOn !== '1' ? Math.round(Math.max(own, opp) * LOOK_PCT / 100) : 0;
        const look = save ? `<span class="pv-combine__look">Look-Rabatt −${LOOK_PCT} %, du sparst ${esc(money(save, format))}</span>` : '';
        item.innerHTML = `<a class="pv-combine__img" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${img}</a>
          <div class="pv-combine__body">
            <a class="pv-combine__name" href="${esc(p.url)}">${esc(p.title)}</a>
            <span class="pv-combine__price">${esc(price)}${compare}</span>${look}
            <div class="pv-combine__row">${action}</div>
            <p class="pv-combine__msg" id="pv-combine-msg" role="status"></p>
          </div>`;
        this.#limitOptions();
      }

      // Sperrt die Knöpfe, die mit der Wahl in den anderen Reihen nicht lieferbar sind.
      #limitOptions() {
        const p = this._picks?.[this._index];
        if (!p) return;
        for (const chip of this.querySelectorAll('.pv-combine__chip')) {
          const i = Number(chip.dataset.opt);
          const ok = p.variants.some(
            (v) => v.available && v.options[i] === chip.dataset.val && Object.entries(this._sel).every(([j, val]) => Number(j) === i || v.options[Number(j)] === val)
          );
          chip.disabled = !ok;
          chip.setAttribute('aria-label', chip.dataset.val + (ok ? '' : ', ausverkauft'));
          chip.setAttribute('aria-pressed', String(this._sel[i] === chip.dataset.val));
        }
      }

      #setBusy(busy) {
        this._busy = busy;
        for (const b of this.querySelectorAll('[data-add]')) b.setAttribute('aria-disabled', String(busy));
      }

      #onChange = () => {};

      #onClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target || this._busy) return;
        const nav = target.closest('.pv-combine__nav');
        if (nav && this._picks) {
          const n = this._picks.length;
          this._index = (this._index + Number(nav.dataset.step) + n) % n;
          this.#show();
          return;
        }
        const chip = target.closest('.pv-combine__chip');
        if (chip && !chip.disabled) {
          const i = Number(chip.dataset.opt);
          this._sel[i] = this._sel[i] === chip.dataset.val ? undefined : chip.dataset.val;
          if (this._sel[i] === undefined) delete this._sel[i];
          const msg = this.querySelector('.pv-combine__msg');
          if (msg) msg.textContent = '';
          this.#limitOptions();
          return;
        }
        const button = target.closest('[data-add]');
        if (!button) return;
        const msg = this.querySelector('.pv-combine__msg');
        let variant = button.dataset.variant;
        if (!variant) {
          const open = [...this.querySelectorAll('.pv-combine__opt')].find((g) => !(Number(g.querySelector('.pv-combine__chip')?.dataset.opt) in this._sel));
          if (open) {
            open.querySelector('.pv-combine__chip:not(:disabled)')?.focus();
            if (msg) msg.textContent = `Bitte erst ${open.dataset.name} wählen`;
            return;
          }
          const p = this._picks[this._index];
          const match = p.variants.find((v) => v.available && Object.entries(this._sel).every(([j, val]) => v.options[Number(j)] === val));
          if (!match) {
            if (msg) msg.textContent = 'Diese Kombination ist gerade ausverkauft';
            return;
          }
          variant = String(match.id);
        }
        this.#add(variant);
      };

      async #add(variant) {
        if (this._busy) return;
        const msg = this.querySelector('.pv-combine__msg');
        if (msg) msg.textContent = '';
        const product = this._picks[this._index];
        this.#setBusy(true);

        let data;
        try {
          const sections = [...document.querySelectorAll('cart-items-component')]
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variant), quantity: 1 }],
              sections: sections.join(','),
              sections_url: window.location.pathname,
            }),
          });
          data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Fehler');
        } catch (error) {
          if (msg) msg.textContent = 'Gerade nicht verfügbar';
          this.#setBusy(false);
          return;
        }

        let cart = null;
        try {
          cart = await fetch(`${root}cart.js`).then((r) => r.json());
        } catch (error) {}

        // Gesperrt bleiben, bis die neue Auswahl steht; so trifft kein zweiter Tipp ein anderes Teil.
        this._added = product.title;
        this._focusAfter = true;
        this._pending = true;
        this._pendingTimer = setTimeout(() => {
          if (!this._pending) return;
          this._picks = (this._picks || []).filter((p) => p !== product);
          if (this._picks.length) {
            this._index = 0;
            this.#frame();
          } else {
            this.replaceChildren();
          }
          this.#done();
        }, 5000);

        this.dispatchEvent(
          new CartAddEvent(cart || {}, 'pv-combine', {
            source: 'pv-combine',
            itemCount: cart ? cart.item_count : undefined,
            variantId: String(variant),
            sections: data.sections,
          })
        );
      }
    }

    if (!customElements.get('pv-combine')) customElements.define('pv-combine', PvCombine);

})();
